import {styled} from "@mui/material/styles"
import Zoom from "@mui/material/Zoom"
import Fab from "@mui/material/Fab"
import {Typography} from "@mui/material"
import env from "../../config/env"

export const StyledZoom = styled(Zoom)`
    transition-delay: 0.3s;
`

export const StyledFab = styled(Fab)`
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    height: 2.75rem;
    width: 2.75rem;
    z-index: 3;
    &:hover {
        background-color: ${props => props.theme.colours.form.buttonSecondary.color};
    }
    background: ${props => props.theme.colours.form.buttonSecondary.color}
        url(${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/back-to-top-chevron.svg);
    @media (pointer: fine) {
        &:hover {
            & > span > p {
                visibility: visible;
            }
        }
    }
`

export const StyledTooltip = styled(Typography)`
    visibility: hidden;
    position: absolute;
    width: max-content;
    right: 115%;
    background-color: #000000;
    color: #ffffff;
    padding: 0.25rem;
    border-radius: 0.125rem;
    font-family: AzoSans;
    font-size: 0.625rem;
    text-transform: capitalize;
`
